<template>
  <div>
    <nuxt />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import BuildBadge from '@/components/common/BuildBadge'
import { buildSeoHead } from '@/helpers/seo'

export default {
  components: { BuildBadge },
  head() {
    return {
      // Canonical (and noindex where the route has no search value) for every
      // page using this layout — see helpers/seo.js.
      ...buildSeoHead(this.$route.path),
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
    }
  },
}
</script>
